export default {
  setAddAvailabilityDialog(state, payload) {
    state.addAvailabilityDialog = payload;
  },
};
